/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedDocumentRejectionReasonList200,
  GetApiV1CourseregistrationSharedDocumentRejectionReasonList401,
  GetApiV1CourseregistrationSharedDocumentRejectionReasonList500,
  GetApiV1CourseregistrationSharedDocumentRejectionReasonListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedDocumentRejectionReasonList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedDocumentRejectionReasonList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentRejectionReasonList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedDocumentRejectionReasonList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentRejectionReasonList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedDocumentRejectionReasonList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentRejectionReasonList500>;

export const getApiV1CourseregistrationSharedDocumentRejectionReasonListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedDocumentRejectionReasonList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentRejectionReasonListQueryResponse>;
